import { Component, ViewEncapsulation } from '@angular/core';

import { EmailImageAssetDirective } from '../../directives/email-image-asset.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';

@Component({
  selector: 'email-tellent-products-footer',
  styleUrl: './tellent-products-footer.component.less',
  template: `
    <table class="tellent-logos-wrap">
      <tr>
        <td>
          <a href="https://recruitee.com/" target="_blank">
            <img
              class="logo"
              [src]="'assets/logo-small-ats.png'"
              [width]="32"
              [height]="32"
              alt="Recruitee"
            />
          </a>
        </td>
        <td>
          <a href="https://kiwihr.com/" target="_blank">
            <img
              class="logo"
              [src]="'assets/logo-small-hris.png'"
              [width]="32"
              [height]="32"
              alt="KiwiHr"
            />
          </a>
        </td>
      </tr>
    </table>
  `,
  imports: [EmailImageAssetDirective],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class TellentProductsFooterComponent {}
